<template>
    <div v-if="!loading">
        <div v-if="selectEnvio">
            <div class="row justify-content-center">
                <div :class="!esMovil ? 'd-flex justify-content-center col-12 col-md-8' : 'col-12 col-md-8 text-center'">
                    <input class="mr-2" type="text" v-model="search" placeholder="Search"/>
                    <b-form-select class="mt-4 mr-2" v-model="selected" :options="options"/>
                    <button class="mt-2 button" @click="changeInvitaciones">{{isInvitaciones ? $t('perfil.pedidos')  :  $t('perfil.invitaciones_recibidas')}}</button>
                </div>
                <div class="mt-4 col-12 col-md-8" v-if="!isInvitaciones">
                    <ul class="list-group list-group-flush">
                        <template v-if="pedidos.length > 0">
                            <PedidoDetalle
                                v-for="pedido in pedidos"
                                :key="pedido.id"
                                :pedido="pedido"
                                @actualizar="getPedidos"
                                @enviar="EnviarEntradas"
                            />
                        </template>
                        <li class="text-center list-group-item" v-else>
                            <h3>
                                {{ $t('perfil.no_pedidos') }}
                            </h3>
                        </li>
                    </ul>
                </div>
                <div class="mt-4 col-12 col-md-8" v-else>
                    <ul class="list-group list-group-flush">
                        <template v-if="invitacionesPedidos.length > 0">
                            <InvitacionesDetalle
                                v-for="pedido in invitacionesPedidos"
                                :key="pedido.id"
                                :esMovil="esMovil"
                                :pedido="pedido"
                                @actualizar="getPedidos"
                                @enviar="EnviarEntradas"
                            />
                        </template>
                        <li class="text-center list-group-item" v-else>
                            <h3>
                                {{ $t('perfil.no_pedidos') }}
                            </h3>
                        </li>
                    </ul>
                </div>
                <div class="flex col-12">
                    <b-pagination
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                        aria-controls="my-table"
                        class="justify-content-center"
                    />
                </div>
            </div>
        </div>
        <div v-else>
            <Envio :pedido="selectedPedido" @atras="atras"/>
        </div>
    </div>
    <div style="padding: 50px;" v-else>
        <LoaderComponent/>
    </div>
</template>

<script setup>
    import { ref, watch, onMounted } from 'vue';
    import store from '@/store';
    import { debounce } from 'lodash';
    import { config } from '@/config.js';
    import PedidoDetalle from '@/components/frontend/perfil/PedidoDetalle';
    import Envio from '@/components/frontend/perfil/pedido/Envio';
    import InvitacionesDetalle from '@/components/frontend/perfil/InvitacionesDetalle';
    import { useVersionMovil } from '@/composables/common/useVersionMovil';

    const { esMovil } = useVersionMovil();

    const currentPage = ref(1);
    const perPage = ref(10);
    const rows = ref(1);
    const pedidos = ref([]);
    const search = ref('');
    const selected = ref('actuales');
    const options = [
        { value: 'actuales', text: 'Actuales' },
        { value: 'pasados', text: 'Pasados' }
    ];
    const selectEnvio = ref(true);
    const selectedPedido = ref(null);
    const isInvitaciones = ref(false);
    const invitacionesPedidos = ref([]);
    const loading = ref(false);

    const getPedidos = () => {
        loading.value = true;

        const data = {
            filters: {
                page: currentPage.value,
                per_page: perPage.value,
                search: search.value,
                tipo: selected.value
            },
        };

        store.dispatch(config.getVuexAlias('front.perfil.pedidos'), data).then(res => {
            pedidos.value = res.data.data;
            currentPage.value = res.data.meta.current_page;
            perPage.value = res.data.meta.per_page;
            rows.value = res.data.meta.total;
            loading.value = false;
        });
    };

    const getInvitaciones = () => {
        loading.value = true;

        const data = {
            filters: {
                page: currentPage.value,
                per_page: perPage.value,
                search: search.value,
                tipo: selected.value
            },
        };

        store.dispatch(config.getVuexAlias('front.perfil.invitaciones'), data).then(res => {
            invitacionesPedidos.value = res.data.data;
            currentPage.value = res.data.meta.current_page;
            perPage.value = res.data.meta.per_page;
            rows.value = res.data.meta.total;
            loading.value = false;
        });
    };

    const EnviarEntradas = pedido => {
        selectedPedido.value = pedido;
        selectEnvio.value = false;
    };

    const atras = () => {
        selectEnvio.value = true;
        selectedPedido.value = null;
        getPedidos();
    };

    const changeInvitaciones = () => {
        isInvitaciones.value = !isInvitaciones.value;
        get();
    };

    const get = () => {
        if (isInvitaciones.value) {
            debouncedGetInvitaciones();
        } else {
            debouncedGetPedidos();
        }
    };

    const debouncedGetPedidos = debounce(getPedidos, 500);
    const debouncedGetInvitaciones = debounce(getInvitaciones, 500);

    watch(search, () => {
        get();
    });

    watch(selected, () => {
        get();
    });

    watch(currentPage, () => {
        get();
    });

    onMounted(() => {
        getPedidos();
    });
</script>
<style scoped>
    :deep(.page-item.active .page-link) {
        z-index: 2 !important;
    }
</style>
